<lib-fieldset
  class="bootstrap-wrapper"
  textTitle="Filtros de búsqueda">

  <form
    [formGroup]="fGroup"
    (ngSubmit)="search.emit()"
    novalidate>

    <ng-content></ng-content>

    <lib-search-form-buttons
      (clear)="clear.emit()"
      [disabled]="disabled">
    </lib-search-form-buttons>

  </form>

</lib-fieldset>
